<template>
    <div id="container" :style="{ width: '100%', height: '100%' }" class="AISearchPage">



        <div class="gutter-row QP" :style="pageContentStlye">
            <div class="gutter-box" style="position: relative;padding-bottom:0px;">
                <div style="text-align: center;" class="QP-Header">
                    <div v-if="show">
                        <img src="../../assets/ailogo.png" :style="{ 'margin-top': show == true ? '40px' : '10px' }" class="ai-logo">
                        <div class="title-line">AI搜索</div>

                        <div class="sub-title-line">连接全网内容，精准搜索，快速分析并总结的智能助手。</div>

                        <div>
                            <div class="typewriter">
                                <h1 class="typing sub-sub-title-line" style="   
    letter-spacing: 2px;font-size: 13px;
 ">你可以这样问我：介绍一下情报强企这家公司</h1>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div style="font-size: 32px;
    font-weight: 700;
    letter-spacing: 2px;display: flex
;
    justify-content: center;
    align-items: center;">
                            <img src="../../assets/ailogo.png" style="width: 40px;height:40px;margin-right: 10px;">
                            AI搜索
                        </div>
                    </div>

                </div>

                <div style="margin-top: 10px;">
                    <ChatPage :pageStlye="pageStlye" :postParams="postParams" @toChangeSendText="toChangeSendText"
                        @toChangeSendTextTrue="toChangeSendTextTrue" :sendText="sendTextText"
                        :conversationId="conversationId" articleType="网络搜索" @toShow="toShow">
                    </ChatPage>
                </div>

                <!-- <div style="position: absolute;bottom: 30px;    display: flex;width: 100%;justify-content: center;">
                    <div :class="textAreaFocus == true ? 'chat-component areafocus' : 'chat-component'">
                        <div>
                            <div style="display: flex;">
                                <a-textarea :bordered="false" v-model:value="sendText"
                                    :autosize="{ minRows: 1, maxRows: 4 }" placeholder="发消息..." allow-clear
                                    @pressEnter="handleKeyPress" @focus="handleFocus" @blur="handleBlur">



                                </a-textarea>
                                <div v-if="textAreaFocus == true" class="sendButton" @click="toSendText"><img
                                        style="width: 50%;" src="../../assets/send.png">
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div style="padding: 0px 280px;;position: absolute;bottom: 30px;    display: flex;width: 100%;justify-content: center;">
                    <div  :class="{'sendTextContainer':true}">
                    <div :class="{'sendTextArea1':true}">
                   <a-textarea :bordered="false" v-model:value="sendText" style="background-color: white;"
                       :autosize="{ minRows: 1, maxRows: 4 }" placeholder="发消息..."
                   class="AISearchTextArea"      allow-clear @pressEnter="handleKeyPress" @focus="handleFocus" @blur="handleBlur">


                   </a-textarea>

                   <div class="sendButton" style="margin-left: 5px;"  @click="toSendText"><img style="width: 50%;"
                           src="../../assets/send.png">
                   </div>
                   </div>

             
               </div>
                </div>
                <div style="padding: 0px 280px;position: absolute;bottom: 0px;    display: flex;width: 100%;justify-content: center; ">
                    <div style="    font-size: 12px;color: #faad14;margin-top: 5px;text-align: center;">
                        AI会犯错，请核查重要信息
                    </div>
                        
                </div>
                
                <!-- <div style="position: absolute;bottom: 30px;    display: flex;width: 100%;justify-content: center;">
                    <div  :class="{'sendTextContainer':true,'areafocus':textAreaFocus==true?true:false}">
                   
                                    
                   <div :class="{'sendTextArea1':true,'areafocus':textAreaFocus==true?true:fals}">
                   <a-textarea :bordered="false" v-model:value="sendText" style="background-color: white;"
                       :autosize="{ minRows: 1, maxRows: 4 }" placeholder="发消息..."
                       allow-clear @pressEnter="handleKeyPress" @focus="handleFocus" @blur="handleBlur">


                   </a-textarea>

                   <div class="sendButton" style="margin-left: 5px;"  @click="toSendText"><img style="width: 50%;"
                           src="../../assets/send.png">
                   </div>

             
               </div>
               
                    </div>
              
                </div> -->
                <!-- <div style="position: absolute;bottom: 0px;    display: flex;width: 100%;justify-content: center;">
                    <div style="    font-size: 12px;color: #faad14;margin-top: 5px;text-align: center;">
                        AI会犯错，请核查重要信息
                    </div>
                </div> -->


            </div>




        </div>


    </div>

</template>
<script>
export default {
    name: 'QiuuPageDetail'
}
</script>
<script setup>
import router from '@/router';

import { nextTick, onMounted, ref, watch, onUnmounted } from 'vue';

import ChatPage from '../knowledgeComponent/component/chatPage.vue';
import { message } from 'ant-design-vue';

import store from '@/store';
import dayjs from 'dayjs';
const toShow = () => {

    show.value = false
}
const show = ref(true)

const selectTrue = ref(false)

const showType = ref(false)



const sendText = ref('')
const sendTextText = ref({ send: false, sendText: '' })
const pageStlye = ref()
const pageContentStlye = ref()
const conversationId = ref()
const companyId = ref(20641)
const textAreaFocus = ref(false)

const handleFocus = () => {
    textAreaFocus.value = true

}
const handleBlur = () => {
    if (!sendText.value)
        textAreaFocus.value = false

}

onMounted(() => {

    setTimeout(() => {
        var parentELement = document.querySelector('.QP')

        if (parentELement) {

            var childrenElement = document.querySelector('.QP-Header')

            if (childrenElement) {
                console.log(parentELement.offsetHeight + "" + childrenElement.offsetHeight + "childrenElement.offsetHeight")
                var pageHeight = parentELement.offsetHeight - childrenElement.offsetHeight - 40 - 42 - 10
                var pageWidth = document.querySelector('.ant-layout-content')
                console.log(pageWidth, 'pageWidth')
                pageStlye.value = { 'height': pageHeight + 'px', 'overflow-y': 'auto' }
                pageContentStlye.value = { height: '100%', 'flex': 1, 'width': '100%' }
            }
        }



    }, 50)
    // document.getElementById('mainContent').classList.add('Qbg')


})

onUnmounted(() => {
    // document.getElementById('mainContent').classList.remove('Qbg')
})

const changeSendTextTrue = ref(false)
const toChangeSendTextTrue = (val) => {
    changeSendTextTrue.value = val

}




const confirmLoading = ref(false)

const handleKeyPress = async(e) => {
    console.log(e)
    e.preventDefault();
     // 检查是否是Shift+Enter组合键  
     const textarea = e.target
    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    if (e.shiftKey) {
        // sendText.value = sendText.value + '\n'
         // 1️⃣ 在光标处插入换行
    const text = sendText.value
    sendText.value =
      text.slice(0, start) + '\n' + text.slice(end)

    // 2️⃣ Vue 更新后，恢复光标到换行后
    await nextTick()
    textarea.setSelectionRange(start + 1, start + 1)
    }
    else {

        toSendText()
    }


}

const newChat = () => {
    var result = sessionList.value.find(item => item.id == 'newChat')
    if (result == null) {
        sessionList.value.unshift({
            id: "newChat",
            title: '新对话',
            updateTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")
        })
        active.value = "newChat"
        conversationId.value = null
    }
    else {
        message.warning('已经是最新的对话！')
    }

}
const showHistory = ref(false)
const postParams = ref(null)
const toSendParam = (params) => {
    postParams.value = params
    selectTrue.value = true
}
const toSendText = () => {

    if (sendText.value.trim() == '')
        message.warning('发送内容不能为空！')
    else if (changeSendTextTrue.value == true) {
        message.warning('正在请求中，请等待！')
    }
    else {
        changeSendTextTrue.value = true
        sendTextText.value = { send: true, sendText: sendText.value }
    }


}
const toChangeSendText = () => {
    sendText.value = ""
    sendTextText.value = { send: false, sendText: '' }

}


const sessionList = ref([
])





</script>
<style lang="less">
.AISearchTextArea{
    textarea{
        font-size: 16px;
    }
}
</style>
<style lang="less" scoped>
@media (min-width: 1600px) {
    .ai-logo{
        margin-top: 160px !important;
    }
}
.ai-logo{
    height: 90px;
    width: 90px;
}
.sendTextArea {

    .ant-input-affix-wrapper {
        border: none !important;
    }
}
.sendTextContainer.areafocus{
    animation: showChat 1s both;
     .sendTextArea1{
        width: 100% !important;
        .ant-input{
        padding: 4px 11px;
        }
        .ant-input-clear-icon{
            display: block;
        }
     }
    .sendButton {
        height: 30px !important;
        width: 30px !important;
     
    }
}
.sendTextArea1::after{
    content: '';
      display: block;
      width: 100%;
      height: 0;
      border-bottom: 2px solid ; /* 设置底部边框 */
      border-image:  linear-gradient(90deg, rgba(114,91,223,1) 0%, rgba(128,163,213,1) 70%, rgba(189,206,234,1) 100%)  0 0 1 0;
      position: absolute;
      bottom: 0;
      left: 0;
}

.sendTextArea1 {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid rgba(5, 5, 5, 0.06);


    /* border-right-width: 1px !important; */
    /* outline: 0; */
    padding:6px 2px;
 
    z-index: 1000;
    bottom: 0px;
    background-color: white;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    
}
@keyframes showChat {
    0% {
        opacity: 0;
        transform: scale3d(0.3, 0.3, 0.3);
    }

    50% {
        opacity: 1;
    }
}


.AISearchPage {
    .chatContatiner{
        padding: 20px 280px !important;
    }
   
    //    /* global 94%+ browsers support */
    // background: repeating-radial-gradient(circle,#FFFFFF 0%,#E0F2ED 100%) !important; 

    // /* safari 5.1+,chrome 10+ */
    // background: -webkit-repeating-radial-gradient(circle,#FFFFFF 0%,#E0F2ED 100%)  !important;

    // /* ff 3.6+ */
    // background: -moz-repeating-radial-gradient(circle,#FFFFFF 0%,#E0F2ED 100%)  !important;

    // /* opera 11.10+ */ 
    // background: -o-repeating-radial-gradient(circle,#FFFFFF 0%,#E0F2ED 100%)  !important;

    // /* ie 10+ */
    // background: -ms-repeating-radial-gradient(circle,#FFFFFF 0%,#E0F2ED 100%)  !important;
}

#knowledgMenu.ant-layout-sider {
    background: white;

}

.sendTextArea {

    .ant-input-affix-wrapper {
        border: none !important;
    }
}

.historyButton:hover {
    .svgIcon {
        color: #3db4bb !important;
    }

}

.trash:hover {
    color: red !important;
}

.session:hover {
    .sessionTitle {
        color: #3db4bb
    }
}
</style>
<style scoped>
.typewriter {
    width: fit-content;
    margin: auto;
}

.typewriter .typing {


    overflow: hidden;
    /* 保证文字在动画之前隐藏 */
    /* border-right: .15em solid orange; */
    /* 使用边框实现光标 */
    white-space: nowrap;
    margin: 0 auto;
    letter-spacing: .15em;
    /* animation:

        typing 3.5s steps(20, end),
        blink-caret .5s step-end infinite; */
}

/* 光标动画 */
@keyframes blink-caret {

    from,
    to {
        border-color: transparent
    }

    50% {
        border-color: orange
    }
}

/* 打字机动画 */
@keyframes typing {
    from {
        width: 0
    }

    to {
        width: 100%
    }
}

/** style.css **/


.sendTextArea:focus,
.sendTextArea:active,
.sendTextArea:hover {
    border-color: #79d3d9;
    box-shadow: 0 0 0 2px rgb(0 157 166 / 58%);
}

.sendTextContainer {

    /* height: 96px; */
    /*bottom: 72px;*/
    bottom: 0px;
    width: 100%;
    display: flex;
    /* align-items: center; */
    justify-content: center;
}

.sendTextArea {
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid;
    border-color: #e5e5e5;
    border-right-width: 1px !important;
    /*outline: 0;*/
    padding: 5px 10px;
    position: absolute;
    z-index: 1000;
    bottom: 0px;
    background-color: white
}

.sendButton {
    cursor: pointer;
    background-color: #735fdf;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.divFlex {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.session {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 15px;
    cursor: pointer;
}

.session:hover,
.session-active {
    position: relative;
    box-shadow: 0 0 6px 0 rgba(113, 127, 167, .28);
    background-color: #f8f8f8;
}


.session:hover:before,
.session-active:before {
    content: "";
    position: absolute;
    height: 100%;
    width: 2px;
    background-color: #79d3d9;
    top: 0;
    left: 0;

}

.sessionTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.newChatButton {
    margin: 15px 0px;
    cursor: pointer;
    width: 168px;
    height: 40px;
    background: #009da6;
    border-radius: 8px;
    color: white;
    line-height: 40px;
    text-align: center;
}

.historyButton {
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}


.chat-component {
    background: #E7FBFC;
    border: 1px solid #ffffff;
    box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d;


    align-items: center;
    border-radius: 28px;
    padding: 10px 20px;
    transform: none;
    transform-origin: 50% 50% 0px;
    backdrop-filter: blur(25px) saturate(180%);
    -webkit-backdrop-filter: blur(25px) saturate(180%);
    background-color: rgba(244, 245, 245, 0.44);
    border-radius: 28px;
    border: 1px solid rgba(209, 213, 219, 0.3);

}

.chat-component.areafocus {
    width: 100%;
    animation: showChat 1s both;
}

@keyframes showChat {
    0% {
        opacity: 0;
        transform: scale3d(0.3, 0.3, 0.3);
    }

    50% {
        opacity: 1;
    }
}

.chat-component span:nth-of-type(1) {
    background: white;
    border-radius: 28px;
}

.gutter-box {


    height: 100%;
}

.no-padding {
    padding-bottom: 0px !important;
}

.QP {
    margin-right: 5px
}

.historyText {
    color: #1a2029;
    font-family: "PingFang SC";
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
}
</style>
